import React, { Component } from 'react';
import { connect } from 'react-redux';
import { cronLogsAction } from '../../actions';
import { CardBody, Card, CardHeader } from 'reactstrap';
import { TableLoader } from '../../../components/Loaders';
import Pagination from "react-js-pagination";
import { renderCronStatus } from '../../../helpers';
import moment from 'moment'
import { Button, Input } from "reactstrap";

class CronLogs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			page: {
				perPage: 20,
				totalItemsCount: 0
			},
			keywords: ''
		};
		this.getCronLogsData = this.getCronLogsData.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}

	componentDidMount() {
		this.getCronLogsData();
	}

	getCronLogsData() {
		const { dispatch } = this.props;
		const { page, keywords } = this.state;
		let dataToSend = {
			active_page: page.activePage,
			per_page: page.perPage,
			keywords: keywords
		};
		dispatch(cronLogsAction.getCronLogsData(dataToSend));
	}

	handlePageChange(pageNumber) {
		const { page } = this.state;
		page.activePage = pageNumber;
		this.setState({ page }, () => this.getCronLogsData());
	}

	componentWillReceiveProps(props) {
		let { page, activeTab } = this.state;
		page.totalItemsCount = 0;
		if (props.logs) {
			page.totalItemsCount = props.logs.total_records;
		}
		if (props.activeTab) {
			activeTab = props.activeTab;
		}
		this.setState({
			page,
			activeTab
		});
	}
	handleChange(e) {
		const { name, value } = e.target

		this.setState({
			...this.state, [name]: value
		})
	}
	handleSearch() {
		const { page } = this.state

		this.setState({
			...this.state, page: {
				...page, activePage: 1
			}
		}, () => this.getCronLogsData())
	}
	render() {
		const { logs, loading } = this.props;
		const { page, keywords } = this.state;
		return (
			<Card>
				<CardHeader>
					<i className="fas fa-boxes" />
					<strong>Cron Logs</strong>
				</CardHeader>
				<CardBody>
					{loading ? (
						<TableLoader />
					) : (
						<React.Fragment>
							<div className="d-flex mb-2 " >
								<Input name='keywords' className='w-25 mr-2' value={keywords} onChange={this.handleChange} placeholder='Search...' />
								<Button color='primary' onClick={this.handleSearch}>
									Search
								</Button>
							</div>
							<div className="table-responsive-sm  animated fadeIn">
								<table className="table table-sm table-condensed table-striped table-bordered table-outline">
									<thead className="thead-light">
										<tr>
											<th>Cron Name</th>
											<th>Status</th>
											<th>Execute At</th>
											<th>Complete At</th>

										</tr>
									</thead>
									<tbody>
										{logs && logs.cron_list && logs.cron_list.length ? (
											logs.cron_list.map(function (eachData, index) {
												return (
													<React.Fragment>
														<tr>
															<td>{eachData.name}</td>
															<td>{renderCronStatus(eachData.status)}</td>
															<td>{eachData.start_time ? moment(eachData.start_time).format('DD/MM/YYYY hh:mm:ss A') : '-'}</td>
															<td>{eachData.complete_time ? moment(eachData.complete_time).format('DD/MM/YYYY hh:mm:ss A') : '-'}</td>
														</tr>
													</React.Fragment>
												);
											})
										) : (
											<tr>
												<td colSpan="4" className="text-center">
													No Data Found
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							{page.totalItemsCount <= page.perPage ? (
								''
							) : (
								<Pagination
									activePage={page.activePage}
									itemsCountPerPage={page.perPage}
									totalItemsCount={page.totalItemsCount}
									pageRangeDisplayed={5}
									linkClass="page-link"
									itemClass="page-item"
									onChange={this.handlePageChange}

								/>
							)}
						</React.Fragment>
					)}
				</CardBody>
			</Card>
		);
	}
}

function mapStateToProps(state) {
	const { loading, data } = state.getCronLogsData;
	return {
		loading,
		logs: data
	};
}

const connectedCronLogs = connect(mapStateToProps)(CronLogs);
export { connectedCronLogs as CronLogs };
